module.exports = __webpack_public_path__ + "img/triangle-80.ed19f431.gif";